import { useState } from "react";
import SectionHead from "./SectionHead";

const FAQS = [
  {
    q: "88吃瓜复盘到底讲的是什么？",
    a: "88吃瓜复盘是围绕近期热门话题、按时间顺序把起因、经过、高潮、转折到结局串联起来的内容栏目。它把散落在各处的碎片信息整理成一条清晰的线，方便没追完全程的观众一次看懂整件事。",
  },
  {
    q: "大结局之后还有后续内容吗？",
    a: "从目前的收尾讨论来看，正片主线已经画上句号。不过片尾彩蛋埋下了新一季的伏笔，相关衍生话题也还在持续更新。编辑部会在有新进展的第一时间补充新的复盘。",
  },
  {
    q: "想补全前因后果，应该从哪看起？",
    a: "建议从事件时间线开始，按顺序看完起因、经过与高潮，再进入大结局复盘板块了解最终结果，最后回到收尾讨论区参与观点互动，这样就能把整条脉络快速补齐。",
  },
  {
    q: "这里的复盘内容客观吗？如何保证准确性？",
    a: "编辑部坚持尽量以可追溯的公开信息为准，在内容里区分「已确认事实」与「网友推测」，并尽量标注信息来源；一旦有新的公开信息出现，也会第一时间更正和更新。",
  },
  {
    q: "复盘内容多久更新一次？",
    a: "当话题出现新的官方信息、反转或阶段性节点时就会跟进更新，正常情况下无需频繁刷新。你可以通过页脚反馈邮箱告诉我们你想看的话题。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 border-y border-background-200 bg-background-100/60 py-14 md:py-20">
      <div className="page-shell">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div>
            <SectionHead
              kicker="常见问题"
              title="关于这次复盘，你可能想问"
              desc="把评论区最高频的问题集中回答了一遍。如果还有疑问，欢迎通过页脚反馈渠道告诉我们。"
            />
          </div>

          <div className="space-y-3 lg:col-span-2">
            {FAQS.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div
                  key={item.q}
                  className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-200" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : idx)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="text-sm font-black text-foreground-950 md:text-base">{item.q}</h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-all ${
                        isOpen ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700"
                      }`}
                      aria-hidden="true"
                    >
                      <i className="ri-add-line" />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}